import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdate from './components/LatestUpdate';
import FAQSection from './components/FAQSection';
import { siteConfig } from '@/mocks/comics';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteConfig.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: siteConfig.name,
            url: siteConfig.url,
            description: siteConfig.description,
            logo: `${siteConfig.url}/logo.png`,
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryShowcase />
        <LatestUpdate />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}